import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import '@/router/permission.js'
import 'element-plus/dist/index.css'
import '@/assets/styles/border.css'
import '@/assets/styles/reset.css'

import SvgIcon from '@/icons'

// 国际化中文
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 修复 ResizeObserver 错误 - 在最早阶段捕获
const resizeObserverLoopErrRe = /^[^(]*ResizeObserver loop/
const resizeObserverLoopErrRe2 = /^ResizeObserver loop completed with undelivered notifications/

// 捕获全局错误
const originalError = window.console.error
window.console.error = (...args) => {
  if (
    args.length > 0 &&
    typeof args[0] === 'string' &&
    (resizeObserverLoopErrRe.test(args[0]) || resizeObserverLoopErrRe2.test(args[0]))
  ) {
    return
  }
  originalError.apply(window.console, args)
}

// 捕获 window.onerror
const originalOnError = window.onerror
window.onerror = (message, source, lineno, colno, error) => {
  if (
    typeof message === 'string' &&
    (resizeObserverLoopErrRe.test(message) || resizeObserverLoopErrRe2.test(message))
  ) {
    return true // 阻止默认错误处理
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error)
  }
  return false
}

// 捕获未处理的 Promise rejection
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || event.reason?.toString() || ''
  if (
    typeof message === 'string' &&
    (resizeObserverLoopErrRe.test(message) || resizeObserverLoopErrRe2.test(message))
  ) {
    event.preventDefault()
    return
  }
})

// 捕获 Error 事件
window.addEventListener('error', (event) => {
  const message = event.message || event.error?.message || ''
  if (
    typeof message === 'string' &&
    (resizeObserverLoopErrRe.test(message) || resizeObserverLoopErrRe2.test(message))
  ) {
    event.preventDefault()
    event.stopPropagation()
    return false
  }
}, true)

const app=createApp(App)

// Vue 应用错误处理
app.config.errorHandler = (err, instance, info) => {
  const errMsg = err?.message || err?.toString() || ''
  if (
    typeof errMsg === 'string' &&
    (resizeObserverLoopErrRe.test(errMsg) || resizeObserverLoopErrRe2.test(errMsg))
  ) {
    // 忽略 ResizeObserver 错误
    return
  }
  // 其他错误正常处理
  console.error('Vue Error:', err, info)
}

app.use(ElementPlus, {
    locale: zhCn,
})

SvgIcon(app);
app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
